<template>
  <input
    @input="onChangeInput"
    v-model="input_val"
    type="text"
    class="input"
    :class="{ 'input--error': error }"
    ref="finInput"
  />
</template>

<script>
export default {
  name: 'AppInput',
  props: {
    value: [String, Number],
    error: {
      type: Boolean,
      default: false
    },
    decimalPartCount: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      input_val: '',
    }
  },
  watch: {
    value: {
      handler(val_new, val_old) {
        if (!val_old) {
          if (val_new || val_new === 0) this.input_val = String(parseFloat(val_new))
          let [integerPart, decimalPart] = this.input_val.split('.')
          integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
          if (decimalPart) decimalPart = decimalPart.slice(0, this.decimalPartCount)
          this.input_val = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart
        }
      },
      immediate: true
    }
  },
  methods: {
    onChangeInput() {
      this.input_val = this.input_val.replace(/[^\d.,]/g, '')
      let [integerPart, decimalPart] = this.input_val.split(/[.,]/)
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      if (decimalPart) decimalPart = decimalPart.slice(0, this.decimalPartCount)
      this.input_val = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart
      const rawValue = this.input_val.replace(/\s+/g, '')
      this.$emit('input', rawValue || null)
    },
  }
}
</script>

<style lang="sass">
.input
  width: 100%
  padding: 10px 12px 11px
  border: 1px solid $color-border
  border-radius: 6px
  color: $color-text-base
  background-color: #fff
  font-family: $font-family-base
  font-size: 13px
  font-weight: 400
  line-height: 15px
  transition: border-color 0.3s, color 0.3s, background-color 0.3s

  &::placeholder
    color: #818181

  &:focus
    border-color: #aaa

  &[readonly]
    pointer-events: none
    border-color: #ff9416

  &[disabled]
    opacity: 0.7

  &[type="search"]
    padding-right: 30px
    background-image: url("~@/assets/img/search-input.svg")
    background-repeat: no-repeat
    background-position: right 10px center
    background-size: 14px

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0

  &[type=number]
    -moz-appearance: textfield

  &[type=time]
    padding: 8px 12px

.input--error
  border-color: $color-error

.input--center
  text-align: center

.input--300
  max-width: 300px

.input--250
  max-width: 250px

.input--200
  max-width: 200px

.input--150
  max-width: 150px

.input--100
  max-width: 100px

.input--65
  max-width: 65px

.input--min-200
  min-width: 200px
</style>
